module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_7042.3a1947a5.png";